import React, { useEffect, useRef, useState } from "react";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { useFullscreen, useToggle } from "react-use";
import FloatBtn from "./components/FloatBtn";
import classNames from "classnames";
import PageSpin from "../components/PageSpin";
import LoadingBoundary from "components/LoadingBoundary";
import { errorMessage } from "service/service";
import GroupDetail from "./components/GroupDetail";
import useRequest from "../../../utils/useRequest";
import {
    getGroupAnswerView,
    GroupAnswerViewItem
} from "../../../service/group";
import { useParams } from "react-router-dom";
import GroupList from "./components/GroupList";

interface GroupProps {
    activityId: string;
    homeworkId: string;
}

function Group({ activityId, homeworkId }: GroupProps) {
    const history = useHistory();
    const ref = useRef<HTMLDivElement>(null);
    const [isFullscreen, toggleFullScreen] = useToggle(false);
    useFullscreen(ref, isFullscreen, {
        onClose: () => toggleFullScreen(false)
    });

    const [selectItem, setSelectItem] = useState<GroupAnswerViewItem>();
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const [dataList] = useRequest(() => getGroupAnswerView(activityId), {}, []);
    const [showList, setShowList] = useState(true);

    useEffect(() => {
        const index =
            dataList?.findIndex(
                item => item.homeworkId.toString() === homeworkId
            ) || 0;
        setSelectedIndex(index);
        setSelectItem(dataList?.[index]);
    }, [dataList, homeworkId]);

    //上一步
    function goPrev() {
        const prev = dataList?.[selectedIndex - 1];
        if (!prev) return;
        history.replace(prev.homeworkId.toString());
    }

    //下一步
    function goNext() {
        const next = dataList?.[selectedIndex + 1];
        if (!next) return;
        history.replace(next.homeworkId.toString());
    }

    return (
        <div className={classNames(style.root)} ref={ref}>
            {!showList && selectItem && <GroupDetail selectItem={selectItem} />}
            {showList && (
                <GroupList
                    list={dataList || []}
                    selectedIndex={selectedIndex}
                    onChangeSelect={setSelectItem}
                    setShowList={setShowList}
                />
            )}
            <div
                className={style.close}
                role="button"
                onClick={history.goBack}
            />

            <FloatBtn
                list={dataList || []}
                selectedIndex={selectedIndex}
                goPrev={goPrev}
                goNext={goNext}
                isFullscreen={isFullscreen}
                toggleFullScreen={toggleFullScreen}
                showList={showList}
                setShowList={setShowList}
            />
        </div>
    );
}

export default function GroupRoot() {
    const { activityId, homeworkId } = useParams();

    function errorFallback(e: any) {
        return <div>{errorMessage(e)}</div>;
    }

    return (
        <LoadingBoundary fallback={<PageSpin />} errorFallback={errorFallback}>
            <Group activityId={activityId} homeworkId={homeworkId} />
        </LoadingBoundary>
    );
}
